import { t } from '../i18n';

const WIRED_ATTR = 'data-passphrase-whitespace-wired';

export function hasLeadingOrTrailingWhitespace(value: string): boolean {
  return value.length > 0 && value !== value.trim();
}

/** Shows a non-blocking hint when the field has leading/trailing whitespace. Does not trim. */
export function attachPassphraseWhitespaceWarning(input: HTMLInputElement): void {
  if (input.getAttribute(WIRED_ATTR) === '1') {
    return;
  }
  input.setAttribute(WIRED_ATTR, '1');

  const hint = document.createElement('p');
  hint.className = 'muted passphrase-whitespace-warning';
  hint.hidden = true;
  hint.setAttribute('aria-live', 'polite');
  hint.setAttribute('data-i18n', 'vault.passphrase.whitespaceWarning');
  hint.textContent = t('vault.passphrase.whitespaceWarning');
  input.insertAdjacentElement('afterend', hint);

  const refresh = (): void => {
    hint.hidden = !hasLeadingOrTrailingWhitespace(input.value);
  };

  input.addEventListener('input', refresh);
  input.addEventListener('change', refresh);
  refresh();
}

export function attachPassphraseWhitespaceWarnings(
  ...inputs: Array<HTMLInputElement | null | undefined>
): void {
  for (const input of inputs) {
    if (input) {
      attachPassphraseWhitespaceWarning(input);
    }
  }
}
